// extracted by mini-css-extract-plugin
export default {"content":"style_content__ZSqYu","checkbox":"style_checkbox__HC6yd"};